"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAllSelected = void 0;
var checkAllSelected = function (items, selectedUsers, selectedGroups) {
    var totalItems = items.filter(function (item) {
        if (item.type === 'USER') {
            return (selectedUsers.findIndex(function (x) { return x.user.id === item.user.id && x.group.id === item.group.id; }) > -1);
        }
        return selectedGroups.findIndex(function (x) { return x.id === item.group.id; }) > -1;
    }).length;
    return items.length > 0 && totalItems === items.length;
};
exports.checkAllSelected = checkAllSelected;
